import { render, staticRenderFns } from "./PayTip.vue?vue&type=template&id=07efb57e&scoped=true&"
import script from "./PayTip.vue?vue&type=script&lang=js&"
export * from "./PayTip.vue?vue&type=script&lang=js&"
import style0 from "./PayTip.vue?vue&type=style&index=0&id=07efb57e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07efb57e",
  null
  
)

export default component.exports